import React, {Component} from 'react';
import {Polygon} from "react-google-maps";
import {connect} from 'react-redux';
import {
  getNeighbourhoodsColours
} from "../../../actions/Map/dataActions.js";
import {
  setNeighbourhoodHoverName
} from "../../../actions/Map/navActions.js";

class ExploreNeighbourhoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      COLOURS: []
    }
  }

  componentWillMount() {
    getNeighbourhoodsColours();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.colours !== this.props.colours){
      this.setState({ COLOURS: this.props.colours.colours })
    }
  }

  render(){
    let polygons = [];
    let NEIGHBOURHOODS = this.props.neighbourhoods;
    for (let i = 0; i < NEIGHBOURHOODS.length; i++) {
      var colour = this.props.colours[Number(NEIGHBOURHOODS[i].fields.neighbourhood_id)]
      let polygon = NEIGHBOURHOODS[i].fields.geo_shape.coordinates;
      if (polygon.length >= 2) {
        for (let j = 0; j < polygon.length; j++) {
          let newPolygon = (
            <Polygon key={i+'.'+j} paths={polygon[j]}
            onClick = {() => this.props.setNeighbourhood(
              NEIGHBOURHOODS[i].fields.neighbourhood_id
            )}
            onMouseOver={() => this.props.setNeighbourhoodHoverName(NEIGHBOURHOODS[i].fields.name)}
            onMouseOut={() =>  this.props.setNeighbourhoodHoverName(undefined)}
            options={{
                fillColor: colour,
                fillOpacity: 0.2,
                strokeColor: "rgb(255, 255, 255)",
                strokeOpacity: .4,
                strokeWeight: 1.5,
              }}/>
          );
          polygons = [...polygons, newPolygon];
        }
      } else {
        let newPolygon = (
          <Polygon key={i+'.0'} paths={polygon}
          onClick = {() => this.props.setNeighbourhood(
            NEIGHBOURHOODS[i].fields.neighbourhood_id
          )}
          onMouseOver={() => this.props.setNeighbourhoodHoverName(NEIGHBOURHOODS[i].fields.name)}
          onMouseOut={() =>  this.props.setNeighbourhoodHoverName(undefined)}
          options={{
              fillColor: colour,
              fillOpacity: 0.3,
              strokeColor: "rgb(255, 255, 255)",
              strokeOpacity: .4,
              strokeWeight: 1.5,
            }}/>
        )
        polygons = [...polygons, newPolygon];
      }
    }
    return polygons;
  }
}

function mapStateToProps(state) {
  return {
    neighbourhoods: state.nav.neighbourhoods,
    colours: state.nav.colours
  };
}

const actions = {
  getNeighbourhoodsColours,
  setNeighbourhoodHoverName
}

export default connect(mapStateToProps, actions)(ExploreNeighbourhoods);



// WEBPACK FOOTER //
// ./src/components/pages/Map/ExploreNeighbourhoods.js